<template>
  <div class="chart-donut">
    <div class="chart-donut-canvas">
      <div
        v-if="text"
        class="text"
      >
        {{ text }}
      </div>
      <slot
        v-else
        name="text"
      ></slot>
      <svg></svg>
    </div>
    <slot name="details" />
  </div>
</template>

<script>
import * as d3 from 'd3';
import D3Tooltip from '~/utils/d3_tooltip';
import * as d3Selection from 'd3-selection';

export default {
  name: 'AppChartDonut',
  props: {
    values: {
      type: Array,
      required: true,
    },
    text: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 90,
    },
    innerRadius: {
      type: Number,
      default: 38,
    },
    sort: {
      type: Boolean,
      default: true,
    },
    withTooltips: {
      type: Boolean,
      default: false,
    },
    tooltipTemplate: {
      type: String,
      default:
        '<div class="vue-tooltip top chart-tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    },
  },
  data: () => ({
    tooltips: [],
  }),
  mounted() {
    this.buildDonut();
  },
  updated() {
    this.buildDonut();
  },
  methods: {
    buildDonut() {
      const that = this;
      const elTooltip = d3Selection.local();
      const block = d3
        .select(this.$el)
        .select('svg')
        .attr('width', this.size)
        .attr('height', this.size)
        .append('g')
        .attr('transform', 'translate(' + this.size / 2 + ',' + this.size / 2 + ')');
      const pie = d3.pie().value((d) => d.value);

      // Avoid pie() automatically sorting in descending order of values
      if (!this.sort) {
        pie.sort(null);
      }

      const arc = d3
        .arc()
        .innerRadius(this.innerRadius)
        .outerRadius(this.size / 2);

      block
        .selectAll('items')
        .data(pie(this.values))
        .enter()
        .append('path')
        .attr('d', arc)
        .attr('class', (d) => `chart-donut-arc arc-${d.data.key}`)
        .on('mouseover', function (event, d) {
          if (that.withTooltips) {
            // Generate tooltip for each section of the chart
            that.cleanupTooltips();
            if (d.data.tooltip) {
              if (!this.elTooltip?.get(this)) {
                const tooltip = new D3Tooltip(this, d.data.tooltip, {
                  html: true,
                  template: that.tooltipTemplate,
                });

                elTooltip.set(this, tooltip);
                that.tooltips.push(tooltip);
              }
            }
          }
        });
    },
    cleanupTooltips() {
      if (this.tooltips.length) {
        // Cleaning tooltips to avoid accumulating when resizing window
        this.tooltips.forEach((tooltip) => tooltip.dispose());
        this.tooltips.splice(0);
      }
    },
  },
};
</script>
